import { affiliateMerchants } from "../../settings/affiliate";
import {
  BrandExtraBatteries,
  ExtraBattery,
  ExtraBatteryInternal,
} from "../types/products";
import { buildProductRecord } from "../utils/products";

/* Missing:
  - WAVE 2 Add-on Battery         https://us.ecoflow.com/products/ecoflow-wave-2-add-on-battery2?variant=42077365436489
  - WAVE 3 Add-on Battery???      https://us.ecoflow.com/products/ecoflow-wave-3-add-on-battery?variant=54386591006793
  - BLADE Smart Extra Battery       https://uk.ecoflow.com/products/blade-robotic-lawn-mower?variant=48670887838035
  - STREAM Ultra                  https://us.ecoflow.com/products/stream-ultra?variant=54383476179017
*/

const brand = "EcoFlow";
const rawData: ExtraBatteryInternal[] = [
  // Power Kit
  {
    name: "5kWh LFP Battery",
    link: {
      href: "https://us.ecoflow.com/products/lfp-battery-for-48v-system?variant=40520684765257",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/power-kit/5kwh-lfp-battery.webp",
    price: 4068,
    capacity: 5120,
    chemistry: "LFP",
    portType: "PowerKit",
  },
  {
    name: "2kWh LFP Battery",
    link: {
      href: "https://us.ecoflow.com/products/lfp-battery-for-48v-system?variant=40520684732489",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/power-kit/2kwh-lfp-battery.webp",
    price: 1818,
    capacity: 2048,
    chemistry: "LFP",
    portType: "PowerKit",
  },

  // TITAN Series
  {
    name: "TITAN Series Extra Battery",
    // link: {
    //   href: "",
    //   affiliateData: affiliateMerchants.ecoflow,
    //   icon: "EcoFlow",
    // },
    amazon: {
      href: "https://www.amazon.com/dp/B0HJZFV2V8/",
      affiliate: "https://link.amazon/B099kI15o",
    },
    img: "/images/products/ecoflow/titan/titan-battery-5kwh/front.webp",

    //price: "TBD",
    capacity: 5017.6,
    chemistry: "LFP",
    portType: "TITAN",
  },

  // DELTA Pro Ultra Series
  {
    name: "DELTA Pro Ultra Series Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/delta-pro-ultra-x-smart-extra-battery?variant=54732348719177",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FX9R487H/",
      affiliate: "https://amzn.to/4fBRDXh",
    },
    img: "/images/products/ecoflow/delta-pro-ultra-series-smart-extra-battery/front-right.webp",

    price: 2199,
    capacity: 6144,
    chemistry: "LFP",
    portType: "5+8",
  },

  // 4+8
  {
    name: "DELTA Pro 3 Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/delta-pro-3-extra-battery?variant=41385808199753",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0D149GKCZ/",
      affiliate: "https://amzn.to/4xeUIUi",
    },
    img: "/images/products/ecoflow/delta-pro-3-smart-extra-battery/front-right.webp",
    price: 1899,
    capacity: 4096,
    chemistry: "LFP",
    portType: "4+8",
  },
  {
    name: "DELTA Pro Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/delta-pro-smart-extra-battery?variant=40558805385289",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B09PBMZ5WT/",
      affiliate: "https://amzn.to/4yWPfDp",
    },
    img: "/images/products/ecoflow/delta-pro-smart-extra-battery/front-right.webp",
    price: 1199,
    capacity: 3600,
    chemistry: "LFP",
    portType: "4+8",
  },
  {
    name: "DELTA 3 Max Plus Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/delta-3-max-plus-smart-extra-battery?variant=55069632790601",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0FQVDGPV4/",
      affiliate: "https://amzn.to/3TBNP12",
    },
    img: "/images/products/ecoflow/delta-3-max-plus-smart-extra-battery/front-right.webp",
    price: 849,
    capacity: 2048,
    chemistry: "LFP",
    portType: "4+8",
  },

  // XT150
  {
    name: "DELTA 3 Series Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/delta-3-series-smart-extra-battery?variant=41631849971785",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "http://amazon.com/dp/B0DCC1QR9F/",
      affiliate: "https://amzn.to/4pZWqqr",
    },
    img: "/images/products/ecoflow/delta-3-series-smart-extra-battery/front-right.webp",
    price: 409,
    capacity: 1024,
    chemistry: "LFP",
    portType: "XT150",
  },
  {
    name: "DELTA 2 Max Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/delta-2-max-smart-extra-battery?variant=40954813448265",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "",
      affiliate: "",
    },
    img: "/images/products/ecoflow/delta-2-max-smart-extra-battery/front-right.webp",
    price: 799,
    capacity: 2048,
    chemistry: "LFP",
    portType: "XT150",
  },
  {
    name: "DELTA 2 Smart Extra Battery",
    img: "/images/products/ecoflow/delta-2-smart-extra-battery/front-right.webp",
    price: 399,
    capacity: 1024,
    chemistry: "LFP",
    portType: "XT150",
  },
  {
    name: "DELTA Max Extra Battery",
    img: "/images/products/ecoflow/delta-max-extra-battery/front-right.webp",
    price: 699,
    capacity: 2016,
    chemistry: "NMC",
    portType: "XT150",
  },

  // River
  {
    name: "RIVER 3 Plus EB600 Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/river-3-plus-smart-extra-battery?variant=41636546216009",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DS2BM3VL/",
      affiliate: "https://amzn.to/3TYgJZb",
    },
    img: "/images/products/ecoflow/river/river-3-plus-smart-extra-battery-eb600/front-right.webp",
    price: 249,
    capacity: 572,
    chemistry: "LFP",
    portType: "Pogo Pin",
  },
  {
    name: "RIVER 3 Plus EB300 Smart Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/river-3-plus-smart-extra-battery?variant=41636536942665",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    amazon: {
      href: "https://www.amazon.com/dp/B0DS2BWFN7/",
      affiliate: "https://amzn.to/4yYTe2i",
    },
    img: "/images/products/ecoflow/river/river-3-plus-smart-extra-battery-eb300/front-right.webp",
    price: 159,
    capacity: 286,
    chemistry: "LFP",
    portType: "Pogo Pin",
  },
  {
    name: "RIVER Pro Extra Battery",
    link: {
      href: "https://us.ecoflow.com/products/river-pro-river-pro-extra-battery-bundle?variant=31919899050057",
      affiliateData: affiliateMerchants.ecoflow,
      icon: "EcoFlow",
    },
    img: "/images/products/ecoflow/river/river-pro-smart-extra-battery/front-right.webp",
    //price: null,
    capacity: 720,
    chemistry: "NMC",
    portType: "D-Sub 7W2",
  },
];

const extraBatteries: BrandExtraBatteries = {
  name: brand,
  extraBatteries: buildProductRecord<ExtraBatteryInternal, ExtraBattery>(
    rawData,
    brand
  ),
};

export default extraBatteries;
